import React from 'react';
import { FileOrFormQuestion } from '../FileOrFormQuestion';
import { usePropertyPresaleContractFile } from '../../../../queries/PropertyFileFields/NonRentalFiles';

interface PreSaleContractFileParameter {
    propertyGuid: string;
    required: boolean;
    isReview?: boolean;
}

export const PreSaleContractFile: React.FC<PreSaleContractFileParameter> = ({ required, propertyGuid, isReview = false }) => {
    const { handleMode, setHandleMode, filename: uploadFileName, setFilename: setUploadFileName, fileApiId: uploadedFileApiId, setFileApiId: setUploadedFileApiId } = usePropertyPresaleContractFile(propertyGuid);

    return (
        <div className='form-group'>
            <div className='row'>
                <FileOrFormQuestion
                    label='Pre-sale Contract'
                    selector='specSheet'
                    fileType='presale contract'
                    required={required}
                    isReview={isReview}
                    propertyGuid={propertyGuid}
                    handle={handleMode}
                    onHandleChange={setHandleMode}
                    uploadFileName={uploadFileName}
                    onUploadFileNameChange={setUploadFileName}
                    uploadedFileApiId={uploadedFileApiId}
                    onUploadedFileApiIdChange={setUploadedFileApiId}
                />
            </div>
        </div>
    );
};
